export default __webpack_public_path__ + "media/images/mailer/wordmark-8a93a992d2c8ac64361a1bc2c1664250.png";